import type { Router, RouteLocationNormalized } from 'vue-router';

// PRODUCT-26110 Pinia migration: the Vuex store hooks (onChange/onValue/
// onAction/onActionFinish/onMutation) are gone — Pinia consumers use vue
// watch() / store.$onAction directly (see ido-facing's storeObserver for the
// legacy-contract adapter). Only the router-based hooks remain.
interface ApplicationPart {
    router: Router | null;
}

// The vestigial generics keep the many `ApplicationObserver<any, any, any>`
// references across the app frameworks compiling unchanged.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default class ApplicationObserver<S = any, A = any, M = any> {
    private app: ApplicationPart;
    private subscriptions: (() => any)[] = [];

    public constructor(app: ApplicationPart) {
        this.app = app;
    }

    public onRouteChange(handler: (to: RouteLocationNormalized, from: RouteLocationNormalized) => any) {
        if (!this.app.router) {
            throw new Error('Unable to listen for route changes on not initialized router.');
        }
        this.subscriptions.push(this.app.router.afterEach((to, from) => {
            handler(to, from);
        }) as () => any);
    }

    public onRoute(name: string, handler: (route: RouteLocationNormalized, from: RouteLocationNormalized) => any) {
        this.onRouteChange((to, from) => {
            if (to && to.name === name) {
                handler(to, from);
            }
        });
    }

    public removeListeners() {
        for (const unsubscribe of this.subscriptions) {
            unsubscribe();
        }
        this.subscriptions = [];
    }
}
